import { render, staticRenderFns } from "./VDPLForm.vue?vue&type=template&id=651fa62d&scoped=true&"
import script from "./VDPLForm.vue?vue&type=script&lang=js&"
export * from "./VDPLForm.vue?vue&type=script&lang=js&"
import style0 from "./VDPLForm.vue?vue&type=style&index=0&id=651fa62d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651fa62d",
  null
  
)

export default component.exports